var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({staticClass:"error",attrs:{"tile":"","depressed":""},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }